import { render, staticRenderFns } from "./CombatPVPFight.vue?vue&type=template&id=40132cfe&scoped=true&"
import script from "./CombatPVPFight.vue?vue&type=script&lang=js&"
export * from "./CombatPVPFight.vue?vue&type=script&lang=js&"
import style0 from "./CombatPVPFight.vue?vue&type=style&index=0&id=40132cfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40132cfe",
  null
  
)

export default component.exports